import { useEffect, useRef } from 'react';
import { Field } from '@eti/form';
import { jsx as _jsx } from "react/jsx-runtime";
const SeedControl = ({
  input,
  availableSegments
}) => {
  var _input$value;
  const hasSeeded = useRef(false);
  const isEmpty = !((_input$value = input.value) !== null && _input$value !== void 0 && _input$value.length);
  const {
    onChange
  } = input;
  useEffect(() => {
    if (hasSeeded.current || !isEmpty || availableSegments.length === 0) {
      return;
    }
    hasSeeded.current = true;
    onChange(availableSegments);
  }, [availableSegments, isEmpty, onChange]);
  return null;
};
const SegmentsSeedField = ({
  productName,
  availableSegments
}) => /*#__PURE__*/_jsx(Field, {
  availableSegments: availableSegments,
  component: SeedControl,
  name: `${productName}.segments`,
  useRHF: true
});
export default SegmentsSeedField;
//# sourceMappingURL=SegmentsSeedField.js.map